import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="暖暖爱视频免费观看-高清完整版在线播放 | 免费视频在线观看"
        description="暖暖爱视频免费观看，提供高清完整版在线播放服务。无需注册、无需下载，随时随地免费畅享暖暖爱全集视频内容，画质清晰流畅，支持手机电脑多端观看。"
        keywords="暖暖爱视频免费,暖暖爱免费观看,暖暖爱高清视频,暖暖爱完整版,暖暖爱在线播放,暖暖爱全集,免费视频在线观看"
        canonicalUrl="https://www.nuannuanai.com/"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '暖暖爱视频',
            url: 'https://www.nuannuanai.com/',
            description: '暖暖爱视频免费观看，提供高清完整版在线播放服务。无需注册、无需下载，随时随地免费畅享暖暖爱全集视频内容。',
            inLanguage: 'zh-CN',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.nuannuanai.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '暖暖爱视频',
            url: 'https://www.nuannuanai.com/',
            description: '免费高清视频在线观看平台',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              email: 'support@nuannuanai.com',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '暖暖爱视频需要注册才能观看吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '完全不需要！暖暖爱视频致力于为用户提供最便捷的观看体验，无需注册、无需登录，打开网站即可免费观看所有高清视频内容。',
                },
              },
              {
                '@type': 'Question',
                name: '暖暖爱视频支持哪些设备观看？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '暖暖爱视频全面支持手机、平板、电脑等多种设备观看。',
                },
              },
              {
                '@type': 'Question',
                name: '视频画质怎么样？能否观看高清内容？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '暖暖爱视频所有内容均提供高清画质，最高支持1080P清晰度。',
                },
              },
              {
                '@type': 'Question',
                name: '暖暖爱视频是否收费？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '暖暖爱视频始终坚持免费服务，所有视频内容均可免费观看。',
                },
              },
            ],
          }),
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedVideos />
        <LatestArticles />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}